import { render, staticRenderFns } from "./AIUsage.vue?vue&type=template&id=00fdb148"
import script from "./AIUsage.vue?vue&type=script&lang=js"
export * from "./AIUsage.vue?vue&type=script&lang=js"
import style0 from "./AIUsage.vue?vue&type=style&index=0&id=00fdb148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports